<template lang="pug">
.phoneView
  .arrow_icon(@click="$router.go(-1)")
    img(src="@/assets/images/arrow_left.svg", alt="alt")
  h1 零碳智慧旅生活
  p 輸入手機號碼

  .phone_box
    multiselect(
      v-model="country_code",
      placeholder="Fav No Man’s Sky path",
      label="title",
      track-by="title",
      :options="country_code_options",
      :option-height="104",
      :custom-label="customLabel",
      :show-labels="false"
      :searchable="false",
    )
      template(slot="singleLabel", slot-scope="props")
        //- img.option__image(:src="props.option.img")
        span.option__desc
          span.option__title {{ props.option }}
      template(slot="option", slot-scope="props")
        //- img.option__image(:src="props.option.img")
        .option__desc
          span.option__small {{ props.option }}
    .phone_number_box(:class="{on_focus: input_focus}")
      input.phone_number(type="number" @focus="onfocus" @blur="onblur" placeholder="你的手機號碼" v-model='phone_number')

  button.stepNext(:class="{active: phone_number}" @click="processAuthPhoneNumber")
    .step-txt 下一步
</template>
<script>
import Multiselect from "vue-multiselect";
export default {
  name: "phone-num",
  components: {
    Multiselect,
  },
  data () {
    return {
      phone_number: '',
      country_code: '+886',
      country_code_options: [
        '+1',
        '+44',
        '+93',
        '+54',
        '+43',
        '+61',
        '+973',
        '+880',
        '+32',
        '+975',
        '+591',
        '+55',
        '+855',
        '+237',
        '+86',
        '+1264',
        '+1268',
        '+297',
        '+1441',
        '+1767',
        '+1473',
        '+1758',
        '+57',
        '+ˊ65',
        '+243',
        '+41',
        '+49',
        '+45',
        '+20',
        '+34',
        '+503',
        '+358',
        '+679',
        '+33',
        '+995',
        '+233',
        '+30',
        '+502',
        '+967',
        '+509',
        '+504',
        '+852',
        '+91',
        '+354',
        '+62',
        '+964',
        '+353',
        '+39',
        '+1876',
        '+962',
        '+7',
        '+254',
        '+81',
        '+82',
        '+965',
        '+352',
        '+853',
        '+389',
        '+261',
        '+60',
        '+960',
        '+52',
        '+212',
        '+47',
        '+674',
        '+64',
        '+505',
        '+234',
        '+92',
        '+507',
        '+675',
        '+351',
        '+595',
        '+40',
        '+7',
        '+250',
        '+966',
        '+381',
        '+248',
        '+94',
        '+65',
        '+249',
        '+46',
        '+66',
        '+886',
        '+676',
        '+90',
        '+256',
        '+380',
        '+971',
        '+598',
        '+998',
        '+58',
        '+96',
      ],
      input_focus: false,
      send_status: false
    };
  },
  methods: {
    customLabel ({ title }) {
      return `${title}`
    },
    onfocus () {
      this.input_focus = true
    },
    onblur () {
      this.input_focus = false
    },
    processAuthPhoneNumber () {
      if (this.send_status) {
        return
      }

      let phoneNumber = this.$root.common.getPhoneCode(this.country_code.title, this.phone_number)
      this.$root.apis.sendLogToSlack("=> 電話號碼: " + phoneNumber)

      // 請求送出簡訊
      let vm = this
      this.send_status = true
      this.$root.apis.sendSmsCodeToPhoneNumber({
        userId: this.$root.user.userId,
        cellphone: phoneNumber
      }, function () {
        vm.$root.phone = phoneNumber
        vm.$root.goPage('/sms-verification')
      }, function () {
        vm.send_status = false
        alert("發送簡訊失敗")
      })
    }
  },
  watch: {
    country_code (_value) {
      if (_value === null) {
        this.country_code = { title: '+886', img: require("@/assets/images/ROC.svg") }
      }
    }
  },
  mounted () { },
};
</script>
<style lang="sass" scoped>
.phoneView
  background-color: #0000
  position: relative
  .arrow_icon
    position: absolute
    left: 6.1vmin
    top: 6vmin
  h1
    font-size: 36px
    color: #fff
    text-align: center
    padding-top: 28.5vmin
  p
    font-size: 20px
    color: #fff
    text-align: center
    margin-top: 40px
  .phone_box
    display: flex
    gap: 10px
    width: 90vmin
    margin: 30vmin auto 0
    .multiselect
      border-radius: 100px
      border: 1.5px solid #505251
      padding: 0vmin 4.2vmin
      min-width: 34vmin
      height: 13.5vmin
      outline: none
      &.multiselect--active
        border: 1.5px solid #22F48F
      ::v-deep .multiselect__tags
        height: 100%
        display: flex
      ::v-deep .multiselect__single
        display: flex
        gap: 8px
        align-items: center
      ::v-deep .multiselect__option
        display: flex
        gap: 8px
        align-items: center
        padding: 3vmin 4vmin
        border-bottom: 0.5px solid rgba(17, 17, 17, 0.25)
      
      .option__title
        color: #fff
        font-size: 4.4vmin
        position: relative
        bottom: .2vmin
      .option__desc
        color: #000
        font-size: 4.4vmin
        position: relative
        bottom: .2vmin
        flex: 1
      ::v-deep .multiselect__content-wrapper
        background: #E5E5E5
        width: 200px
        overflow: auto
        border-radius: 10px
        position: relative
        right: 3vmin
        box-shadow: 0px 0px 20px 0px rgba(34, 244, 143, 0.80)
      ::v-deep .multiselect__content
        width: 100%
        


    .phone_number_box
      flex-grow: 1
      
      border: 1.5px solid #505251
      border-radius: 100px
      height: 13.5vmin
      min-width: 53.5vmin
      &.on_focus
        border: 1.5px solid #22F48F
      .phone_number
        width: 100%
        padding: 0 4.2vmin
        background: rgba(0,0,0,0)
        color:  #fff
        font-size: 5vmin;
        height: 12.5vmin

  .stepNext
    position: fixed
    left: 0
    right: 0
    bottom: 18.25vmin
    width: 53.75vmin
    margin: auto
    border-radius: 12.5vmin
    background-color: #898A8D
    border: none
    padding: 11px 0px
    &.active
      background-color: #22F48F
    .step-txt
      text-align: center
      font-size: 6vmin
      font-weight: 700
      color: #1E1E1E
</style>
